<template>
  <div class="matrix-block container max-w-screen-xl">
    <h2 v-if="heading" class="px-4 fluid-xl leading-tight font-medium" v-html="heading"></h2>
    <div v-if="description" class="copy-text px-4 mt-4 fluid-lg font-light leading-normal" v-html="description"></div>
    <ExerciseCard :exercise="exerciseWithOverwrites" />
  </div>
</template>

<script>
import ExerciseCard from '@/components/exercises/ExerciseCard';
import { validObjectId } from '@/utils/algolia';

export default {
  name: 'ExercisePreview',
  components: {
    ExerciseCard,
  },
  props: {
    exerciseObjectId: {
      type: String,
      default: null,
    },
    exerciseData: {
      type: Object,
      default: null,
    },
    heading: {
      type: String,
      default: null,
    },
    description: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      default: null,
    },
    shortDescription: {
      type: String,
      default: null,
    },
    longDescription: {
      type: String,
      default: null,
    },
    practiceLabelKey: {
      type: String,
      default: 'none',
    },
    practiceValue: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      active: false,
      exercise: null,
    };
  },
  async fetch() {
    if (this.exerciseData) {
      this.exercise = this.exerciseData;
    } else if (validObjectId(this.exerciseObjectId))
      try {
        this.exercise = await this.$algoliaWorkouts.fetchExerciseById(this.exerciseObjectId);
      } catch (error) {
        this.$sentry.captureException(error);
      }
  },

  computed: {
    /**
     * translate practiceLabelKey to practiceLabel
     * log missing translations to sentry
     */
    practiceLabel() {
      if (!this.practiceLabelKey || this.practiceLabelKey === 'none') return null;

      let translationKey = `exercises.practiceLabel.${this.practiceLabelKey}`;

      // fix because cms returns the key wrong
      if (this.practiceLabelKey === 'Seconds per side') {
        translationKey = `exercises.practiceLabel.${this.practiceLabelKey.toLowerCase()}`;
      }

      const translationValue = this.$t(translationKey);
      if (translationValue === translationKey) {
        this.$sentry.captureException(`translation key not found: ${translationKey}`);
        return null;
      }
      return translationValue;
    },
    /**
     * overwrites fetched algolia exercise with local props from craft
     * @returns {object} - exercise with overwritten attrs by this component props
     */
    exerciseWithOverwrites() {
      if (!this.exercise) return null;

      const mergePropKeys = ['title', 'longDescription', 'shortDescription', 'practiceValue', 'practiceLabel'];
      const exercise = { ...this.exercise };

      for (const key of mergePropKeys) {
        if (this[key]) {
          exercise[key] = this[key];
        }
      }

      return exercise;
    },
  },
};
</script>
